module.exports = __webpack_public_path__ + "static/media/bg2.c07b6486.svg";